var map = {
	"./default/assets/SnappyIcon.svg": 9116,
	"./default/assets/font.css": 3525,
	"./default/assets/tailwind.css": 8261,
	"./gerstl/assets/font.css": 6480,
	"./gerstl/assets/images/color.png": 190,
	"./gerstl/assets/images/hue.png": 4755,
	"./gerstl/assets/logo.svg": 8290,
	"./krediflow/assets/SnappyIcon.svg": 7750,
	"./krediflow/assets/font.css": 2665,
	"./krediflow/assets/tailwind.css": 3612,
	"./motolino/assets/font.css": 2311,
	"./motolino/assets/images/color.png": 1472,
	"./motolino/assets/images/hue.png": 2573,
	"./motolino/assets/logo.svg": 9119,
	"./neuraxis/assets/font.css": 113,
	"./neuraxis/assets/images/color.png": 561,
	"./neuraxis/assets/images/hue.png": 1215,
	"./neuraxis/assets/logo.svg": 3472,
	"./providebit/assets/font.css": 9215,
	"./providebit/assets/images/color.png": 4089,
	"./providebit/assets/images/hue.png": 139,
	"./providebit/assets/logo.svg": 5646,
	"./sprachtechnik/assets/font.css": 4041,
	"./sprachtechnik/assets/images/color.png": 1945,
	"./sprachtechnik/assets/images/hue.png": 5035,
	"./sprachtechnik/assets/logo.svg": 213,
	"./sula/assets/font.css": 9993,
	"./sula/assets/images/color.png": 860,
	"./sula/assets/images/hue.png": 2362,
	"./sula/assets/logo.svg": 9072
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 4748;